/**
 * BottomBar — Mobile 5-item navigation (Home / Leads / PPC / AI / More).
 * Visible only ≤860px (CSS-driven). Dot-badges for unread notifications.
 */
import { Home, Users, Target, Sparkles, Menu } from 'lucide-react';
import { MOBILE_BOTTOM_ITEMS, TAB_MAP } from './nav';

const ICON_BY_KEY = {
  overview: Home,
  leads: Users,
  ppcads: Target,
  gya_queue: Sparkles,
};

export default function BottomBar({ active, onNav, onMore, notificationCounts = {} }) {
  return (
    <div className="mobile-bottombar" data-testid="bottom-bar">
      {(MOBILE_BOTTOM_ITEMS || []).map((key) => {
        const item = TAB_MAP[key];
        const Icon = ICON_BY_KEY[key] || Home;
        const n = item?.badgeKey ? notificationCounts[item.badgeKey] : 0;
        return (
          <button
            key={key}
            className={`mb-item${active === key ? ' active' : ''}`}
            data-testid={`bottom-${key}`}
            onClick={() => onNav(key)}
          >
            <Icon size={20} />
            {item?.label || key}
            {n > 0 && <span className="mb-badge" />}
          </button>
        );
      })}
      <button className="mb-item" data-testid="bottom-more" onClick={onMore}>
        <Menu size={20} />
        More
      </button>
    </div>
  );
}
